import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { YES_NO, NUMBER, TEXT } from "const"
import { RrsCategory } from "server/models"
import {
    StoreType,
    setRrsTemplateCategoriesSelected,
} from "client/store"
import {
    TableColumn,
    TablePopoverData,
    TablePopover,
} from "client/components"

const Columns = () => {
    const categoryList = useSelector((state: StoreType) => state.rrsTemplate.categories.categoryList)
    const childParent = useSelector((state: StoreType) => state.rrsTemplate.categories.categoryChildParent)
    const filters = useSelector((state: StoreType) => state.rrsTemplate.categories.filters)
    const selected = useSelector((state: StoreType) => state.rrsTemplate.categories.selected)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const selectCategory = (category: RrsCategory) => {
        let selectedCopy
        if (selected && selected.includes(category.id)) {
            selectedCopy = selected.filter((id) => (id !== category.id))
        } else {
            selectedCopy = selected ? selected.slice() : []
            selectedCopy.push(category.id)
        }
        dispatch(setRrsTemplateCategoriesSelected(selectedCopy))
    }

    const columns: TableColumn[] = [
        {
            field: "name",
            header: lang.name,
            collapsible: true,
            cellMinWidth: "200px",
            onClick: selectCategory,
            formatter: (category: RrsCategory) => {
                let categoryName: string

                if (filters && filters.search && filters.search.length) {
                    const parentArray: string[] = []
                    const addParent = (parentId: number) => {
                        if (parentId) {
                            const parent = categoryList[parentId]
                            if (parent) parentArray.unshift(parent.shortName.length ? parent.shortName : parent.name)
                            addParent(childParent[parentId])
                        }
                    }
                    addParent(category.id)
                    categoryName = parentArray.length ? parentArray.join(" > ") : category.name
                } else {
                    categoryName = category.name
                }

                return categoryName
            },
        },
        {
            field: "shortName",
            header: lang.shortName,
            cellMinWidth: "100px",
            onClick: selectCategory,
        },
        {
            field: "description",
            header: lang.description,
            cellMinWidth: "200px",
            cellMaxWidth: "300px",
            onClick: selectCategory,
        },
        {
            field: "order",
            header: lang.order,
            cellMinWidth: "100px",
            onClick: selectCategory,
        },
        {
            field: "customVariables",
            header: lang.customVariables,
            cellMinWidth: "150px",
            onClick: selectCategory,
            formatter: (category: RrsCategory) => {
                const dataList: TablePopoverData[] = []
                if (category.customVariablesParsed) {
                    category.customVariablesParsed.forEach((custom) => {
                        let value: string
                        if (custom.type === YES_NO) {
                            if (custom.value === true) value = lang.yes
                            if (custom.value === false) value = lang.no
                        }
                        if (custom.type === NUMBER || custom.type === TEXT) {
                            value = custom.value.toString()
                        }

                        dataList.push({
                            id: custom.index.toString(),
                            title: `${custom.name}: ${value}`,
                        })
                    })
                }

                return (
                    <TablePopover
                        id={`customVariables${category.id}`}
                        dataList={dataList}
                        placement="left"
                        listStyle
                        title={lang.customVariables}
                        showFirst={dataList.length === 1}
                        editAccess={false}
                    />
                )
            },
        },
    ]

    return columns
}
export default Columns
